import { AssetDTO, typeDetails } from "src/app/shared/models/models";

export class flag{
  url:string = '';
}
export class countryDto{
  name:string = '';
  code:string = '';
  order:string = '';
  flag:flag = new flag()
}


export class countryDetails{
  flatData:countryDto = new  countryDto();
}



export class contactsDTO{
  name:string = '';
  value:string = '';
  isURL:string = '';
  type:typeDetails = new typeDetails();
}
// export class contactsDetails{
 
//   flatData:contactsDTO = new contactsDTO();
  
// }


export class ExhibitionContentDetails {
  conferenceTitle:string = '';
  aboutConference:string = '';
  startDate:string = '';
  endDate:string = '';
  organizer:string = '';
  coverImage:AssetDTO = new AssetDTO();
  country:countryDetails = new countryDetails();
  contacts:contactsDTO = new contactsDTO();
  locationGeo:string = '';
}

export class ExhibitionContentModel {
  id:string = '';
  flatData: ExhibitionContentDetails = new ExhibitionContentDetails();
}